module.exports = __webpack_public_path__ + "img/core7.2c83fd49.jpg";